(function () {
  const limitedTimeSectionId = window.__limitedTimeSectionId;

  function initLimitedTime() {
    var elem = document.querySelector(`.limited-time__${limitedTimeSectionId} .main-carousels`);

    if (elem && window.innerWidth < 769 && typeof Flickity !== 'undefined') {
      new Flickity(elem, {
        cellAlign: 'left',
        contain: true,
        wrapAround: true,
        pageDots: false,
        prevNextButtons: false,
        selectedAttraction: 0.015,  
        friction: 0.25,            
        draggable: true,
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initLimitedTime();
  });

  document.addEventListener('shopify:section:load', function (event) {
    if (event.detail.sectionId !== limitedTimeSectionId) return;
    initLimitedTime();
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (event.detail.sectionId !== limitedTimeSectionId) return;
    var elem = document.querySelector(`.limited-time__${limitedTimeSectionId} .main-carousels`);
    if (elem && typeof Flickity !== 'undefined') {
      var flkty = Flickity.data(elem);
      if (flkty) flkty.destroy();
    }
  });
})();